// Re-export video resolution type from utility for convenience
export type { TVideoResolutionPreset, IVideoResolutionOption } from '@src/utils/videoConstraints.utils';

export type TAspectRationOptions = 'default (4:3)' | '16:9' | '1:1' | '1:2';

export type TVideoObjectFit = 'fill' | 'contain' | 'cover' | 'scale-down' | 'none';

export type TVideoControls = 'on' | 'off';

export type TLayoutItems = 'TILED' | 'SPOTLIGHT' | 'SIDEBAR' | 'TOP_BAR' | 'BOTTOM_BAR' | 'INSTRUCTOR';

export enum EMainConfigKeys {
  ChatButton = 'chatButton',
  PollButton = 'pollButton',
  questionsButton = 'questionsButton',
  StartScreenButton = 'startScreenButton',
  StartRecordingButton = 'startRecordingButton',
  AboutButton = 'aboutButton',
  EditorButton = 'editorButton',
  EmojiRoomButton = 'emojiRoomButton',
  ExitButton = 'exitButton',
  HideMeButton = 'hideMeButton',
  RaiseHandButton = 'raiseHandButton',
  SettingsButton = 'settingsButton',
  ShareButton = 'shareButton',
  SnapshotRoomButton = 'snapshotRoomButton',
  StartAudioButton = 'startAudioButton',
  StartVideoButton = 'startVideoButton',
  SwapCameraButton = 'swapCameraButton',
  TranscriptionButton = 'transcriptionButton',
  WhiteboardButton = 'whiteboardButton',
  EndMeetingForAll = 'endMeetingForAll',
  ParticipantsButton = 'participantsButton',
  ThreeDotsFooterMenu = 'threeDotsFooterMenu',
}

export enum EChatConfigKeys {
  ChatBanButton = 'chatBanButton',
  ChatEmojiButton = 'chatEmojiButton',
  ChatSendButton = 'chatSendButton',
  PrivateChatButton = 'privateChatButton',
  ChatFileSharingButton = 'chatFileSharingButton',
  ChatSpeechStartButton = 'chatSpeechStartButton',
}

export enum EParticipantsListConfigKeys {
  BanButton = 'banButton',
  EjectAllButton = 'ejectAllButton',
  EjectButton = 'ejectButton',
  MuteButton = 'muteButton',
  UnMuteButton = 'unMuteButton',
}

export enum EPollsConfigKeys {
  PollCreateButton = 'pollCreateButton',
  PollDeleteButton = 'pollDeleteButton',
}

export enum ESettingsConfigKeys {
  LockRoomButton = 'lockRoomButton',
  SendEmailInvitation = 'sendEmailInvitation',
  UnlockRoomButton = 'unlockRoomButton',
  CameraOptionsButton = 'cameraOptionsButton',
  MicOptionsButton = 'micOptionsButton',
  SpeakerOptionsButton = 'speakerOptionsButton',
}

export enum EQuestionsConfigKeys {
  actionsButton = 'actionsButton',
  askAnonymously = 'askAnonymously',
  dismissQuestion = 'dismissQuestion',
  assignQuestionButton = 'assignQuestionButton',
  answerQuestionButton = 'answerQuestionButton',
  deleteQuestionButton = 'deleteQuestionButton',
  submitQuestionsButton = 'submitQuestionsButton',
}

export enum EWhiteboardConfigKeys {
  WhiteboardLockButton = 'whiteboardLockButton',
}

export enum EMagicPenConfigKeys {
  clearAllButton = 'clearAllButton',
  eraserOthersObjButton = 'eraserOthersObjButton',
  floatingButton = 'floatingButton',
  inviteToAnnotateButton = 'inviteToAnnotateButton',
  saveCanvasButton = 'saveCanvasButton',
  showHideButton = 'showHideButton',
}

export enum ECalculatorConfigKeys {
  shareCalculatorButton = 'shareCalculatorButton',
  calculatorShowButton = 'calculatorShowButton',
}

export type TConfigKey = EMainConfigKeys | EChatConfigKeys | ECalculatorConfigKeys;

export type IMainConfig = Record<EMainConfigKeys, boolean>;
export type IChatConfig = Record<EChatConfigKeys, boolean>;
export type IPollsConfig = Record<EPollsConfigKeys, boolean>;
export type ISettingsConfig = Record<ESettingsConfigKeys, boolean>;
export type IQuestionsConfig = Record<EQuestionsConfigKeys, boolean>;
export type IWhiteboardConfig = Record<EWhiteboardConfigKeys, boolean>;
export type IParticipantsListConfig = Record<EParticipantsListConfigKeys, boolean>;
export type IMagicPenConfig = Record<EMagicPenConfigKeys, boolean>;
export type ICalculatorConfig = Record<ECalculatorConfigKeys, boolean>;

export interface IUpdateRoomConfigResponse {
  roomConfig: {
    main: IMainConfig;
    chat: IChatConfig;
    poll: IPollsConfig;
    questions: IQuestionsConfig;
    participantsList: IParticipantsListConfig;
    magicPen: IMagicPenConfig;
    calculator: ICalculatorConfig;
  };
}
